export type RedeemStatus = 0 | 1 | 2 | 3 | 4;
export type RedeemRejectReason = 0 | 1 | 2;

export interface RedeemRequest {
  id: string;
  merchantId: string;
  treasuryId: string;
  amount: number;
  status: RedeemStatus;
  createdAt: string;
  reason?: RedeemRejectReason;
  /** ERC-20 this redeem settles in. The queue is mixed-token, so amounts are only
   *  comparable within the same value here. */
  settlementToken?: string;
  settlementTokenSymbol?: string;
}

export interface CreateRedeemPayload {
  merchantId: string;
  treasuryId: string;
  /** Human units of `settlementToken`. Wire name is legacy — the backend reads amountInVip. */
  amountInVip: number;
  /** Omitted => the contract's default token. */
  settlementToken?: string;
}

export const REDEEM_STATUS: Record<RedeemStatus, string> = {
  0: "Pending",
  1: "In Review",
  2: "In Progress",
  3: "Approved",
  4: "Rejected",
};

export const REDEEM_REJECT_REASON: Record<RedeemRejectReason, string> = {
  0: "Admin rejected the redeem request",
  1: "",
  2: "",
};

export enum REDEEM_STATUS_CODE {
  PENDING = 0,
  APPROVED = 1,
  REJECTED = 2,
}

export enum REDEEM_STATUS_LABEL {
  PENDING = "Pending",
  INREVIEW = "In Review",
  INPROGRESS = "In Progress",
  APPROVED = "Approved",
  REJECTED = "Rejected",
}
